import SplitBilling from "@/components/Orders/SplitBilling"
import usePaymentMethods from "@/hooks/usePaymentMethods"
import { useAppDispatch, useAppSelector } from "@/lib/hooks"
import {
  FormControl,
  FormHelperText,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material"
import { useState, useEffect } from "react"
import {
  setSplitBilling,
  setPaymentMethod,
  setSplitPayments,
  setCashReceived,
  setPaymentStatus,
} from "@/redux/slices/orderFormSlice"
import useSetting from "@/hooks/useSetting"

export function PaymentStatus({
  controller,
  control,
  errors,
  register,
  watch,
  setValue,
}) {
  const Controller = controller
  const dispatch = useAppDispatch()
  const { settingData: paymentStatusData, isLoading: paymentStatusLoading } =
    useSetting("payment-status", "asc")
  const { paymentStatus } = useAppSelector((state) => state.order)

  useEffect(() => {
    if (paymentStatus && setValue) {
      const timeoutId = setTimeout(() => {
        setValue("payment_status", paymentStatus, { shouldValidate: false })
      }, 0)
      return () => clearTimeout(timeoutId)
    }

    const dataArray = paymentStatusData?.data
    const currentStatus = watch("payment_status")

    if (dataArray && dataArray.length > 0 && !currentStatus) {
      const defaultId = dataArray[0].id

      setValue("payment_status", defaultId)
      dispatch(setPaymentStatus(defaultId))
    }
  }, [paymentStatus, setValue, paymentStatusData])

  return (
    <div className="flex rounded-2xl bg-white flex-col flex-1">
      <Typography
        variant="h6"
        className="font-semibold mb-2 flex justify-between mr-4"
      >
        <div> Payment Status</div>
      </Typography>

      <div className="flex justify-between flex-1">
        {paymentStatusLoading ? (
          <div className="flex justify-center py-4">
            <CircularProgress size={24} />
          </div>
        ) : (
          <FormControl>
            <Controller
              name="payment_status"
              control={control}
              render={({ field: { onChange, value } }) => {
                const currentValue = value || paymentStatus || null

                return (
                  <>
                    <ToggleButtonGroup
                      fullWidth
                      exclusive
                      value={currentValue || ""}
                      onChange={(event, newValue) => {
                        if (newValue !== null) {
                          dispatch(setPaymentStatus(newValue))
                          onChange(newValue)
                        }
                      }}
                      aria-label="payment status toggle"
                      className="flex flex-wrap"
                    >
                      {paymentStatusData?.data?.map((method) => (
                        <ToggleButton
                          key={method.id}
                          value={method.id}
                          color={currentValue === method.id ? "primary" : ""}
                          className="flex-1 py-2 text-sm font-medium"
                        >
                          {method.display_name}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>

                    {errors.payment_status && (
                      <FormHelperText error>
                        {errors.payment_status.message}
                      </FormHelperText>
                    )}
                  </>
                )
              }}
            />
          </FormControl>
        )}
      </div>
    </div>
  )
}
